var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question-choices",attrs:{"data-grid":_vm.choices.length}},_vm._l((_vm.choices),function(choice,index){return _c('choice-card',{key:choice._key,class:{
      disabled: _vm.isAnswerSubmitted,
      'selected-answer':
        _vm.selectedChoice === choice._key || _vm.choiceIsSelected(choice._key)
    },attrs:{"title":choice.title,"index":index,"disabled":_vm.isAnswerSubmitted},on:{"change":function($event){return _vm.selectAnswer(choice._key)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }